module.exports = __webpack_public_path__ + "img/bg_pop_top.ee9cd08e.png";